// using cors-anywhere.herokuapp.com because issues with CORS and without that results from API are not showing
const proxyurl = 'https://cors-anywhere.herokuapp.com/';

module.exports = proxyurl;
